import styled from 'styled-components';
import { Row, Select, Col } from 'antd';
import AntButton from 'uiKits/Button';

export const MainLayout = styled.div`
  width: 100%;
  padding: 0 8px 16px;
  .ant-row {
    gap: 10px;
  }
`;

export const ToolbarWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  a {
    color: #000 !important;
  }
  .ant-space-item {
    cursor: pointer;
  }
`;

export const StyledLineSheetsButton = styled(AntButton)`
  font-family: Muli;
  font-weight: bold;
  border-radius: 17.5px;
  border: 2px solid #07af7c;
  background-color: #f7f7f7;
  color: #07af7c;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => (props.disabled ? '#ffffff' : '#07af7c')};
    color: ${(props) => (props.disabled ? 'inherit' : '#ffffff')};
  }

  &:disabled {
    background-color: #f5f5f5; /* Optional: Set a different background for disabled state */
    color: #02b183; /* Optional: Set a different color for disabled state */
    cursor: not-allowed;
    opacity: 0.35;
  }
`;

export const StyledSortBy = styled(Select)`
  width: 150px;
  cursor: pointer;

  .ant-select-selector {
    border-radius: 17.5px !important;
    border: 2px solid #07af7c !important;
    .ant-select-selection-item {
      font-family: Muli;
      font-size: 12px;
      font-weight: bold;
      color: rgb(191, 191, 191);
    }
  }

  .ant-select-arrow {
    color: #07af7c;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  align-content: center;
  gap: 10px;
`;

export const SytledTitle = styled.h4`
  font-family: Muli, Helvetica, Arial, sans-serif;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin: 0px;
  cursor: default;
`;

export const StyledRow = styled(Row)`
  padding: 0 8px 16px;
`;

export const StyledCol = styled(Col)``;
